angular.module('common')
    .service('sentryService', ['appInfoFactory', '$log', function (appInfoFactory, $log) {
        function SentryService(appInfoFactory) {
            var self = this;
            self._appInfoFactory = appInfoFactory;
            self._$log = $log;
        };

        SentryService.prototype.init = function() {
            var self = this;
            self._appInfoFactory.getSentryInfo()
                .success(function(result) {
                        Raven.config(result.DSN, {
                           release : result.Version
                        }).install();
                }).error(function() {
                    self._$log.error('Failed to initialise Raven/Sentry config');
                });
        };

        return new SentryService(appInfoFactory);
    }]);